// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

const image = '/images/popups/specifications/setting_base_width.gif';

export const Header = 'Base Width';

export function Content ({ setPopupContent }: TProps) {
  return (
    <div>
      <div className="multimedia-box" style={{ margin: 0 }}>
        <img src={image} style={{ display: 'block', margin: '0 auto' }} />
        <div
          className="caption"
          style={{
            marginTop: 0,
            padding: '9px 5px 12px 5px',
            color: '#9b9b9b'
          }}>
          <strong>Base Width</strong> is the width of the setting at the bottom
          of the ring.
        </div>
      </div>
    </div>
  );
}
